import { useEffect, useRef, useState } from "react";

export const useDebounce = <T>(value: T, delay = 500) => {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);
	const timerRef = useRef<number | undefined>(undefined);

	useEffect(() => {
		timerRef.current = window.setTimeout(() => setDebouncedValue(value), delay);

		return () => {
			clearTimeout(timerRef.current);
		};
	}, [value, delay]);

	return debouncedValue;
};
